import { Account, ManagementType } from '@ndvr/portfolio-api';

interface UseGrowthAllocationValidationProps {
    growthView: 'portfolio' | 'pinned';
    portfolioAllocationGUID?: string;
    accounts: Account[];
    hasChanges: boolean;
    isSaving: boolean;
}

export const useGrowthAllocationValidation = ({
    growthView,
    portfolioAllocationGUID,
    accounts,
    hasChanges,
    isSaving,
}: UseGrowthAllocationValidationProps) => {
    const isPortfolioInvalid = growthView === 'portfolio' && !portfolioAllocationGUID;
    const isPinnedInvalid =
        growthView === 'pinned' &&
        accounts.some((account) => account.managementType === ManagementType.AUTOMATIC && !account.allocationGUID);
    const isSavingDisabled = isSaving || !hasChanges || isPortfolioInvalid || isPinnedInvalid;

    const getTooltipMessage = () => {
        if (isSaving) {
            return 'Saving changes...';
        }
        if (isPortfolioInvalid) {
            return 'Please select an allocation';
        }
        if (isPinnedInvalid) {
            return 'All automatic accounts must have an allocation';
        }
        if (!hasChanges) {
            return 'No changes to save';
        }
        return '';
    };

    return {
        isSavingDisabled,
        isPortfolioInvalid,
        isPinnedInvalid,
        tooltipMessage: getTooltipMessage(),
    };
};
